<script>
  import {props} from 'bootstrap-vue/src/components/button/button.js'

  export default {
    props: {
      message: { type: String, required: false, default: 'confirmation.message' },
      title: { type: String, required: true },
      ...props
    },
    methods: {
      clicked () {
        this.$bvModal.msgBoxConfirm(this.$t(this.message), {
          title: this.$t('confirmation.title'),
          okVariant: 'danger',
          okTitle: this.$t('confirmation.btn-yes'),
          cancelTitle: this.$t('confirmation.btn-no'),
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
          .then(value => {
            if (value) {
              this.$emit('click')
            }
          })
      }
    }
  }
</script>
<template>
  <b-button
    :title="title"
    @click="clicked"
    :active="active"
    :activeClass="activeClass"
    :append="append"
    :block="block"
    :disabled="disabled"
    :exact="exact"
    :exactActiveClass="exactActiveClass"
    :href="href"
    :noPrefetch="noPrefetch"
    :pressed="pressed"
    :rel="rel"
    :replace="replace"
    :size="size"
    :tag="tag"
    :target="target"
    :to="to"
    :type="type"
    :variant="variant"
  ><slot></slot></b-button>
</template>
